import { LayoutNote } from "@acme/feature";

export default function Web() {
  return (
    <LayoutNote />
  );
}

